import axios from 'axios'
import router from '../router'
import Vue from 'vue'
// 基础请求 学习设计相关请求
const request = axios.create({
  // baseURL: 'http://10.135.192.8:808/api/v1'
})

// 请求拦截器
request.interceptors.request.use( (config)=> {
  // begin add by daqing
  let list = ['api.forclass.net/notes', 'api/Course', 'api/course' , 'CourseAll/api']
  let flag = list.some(item=> {
    if(config.url.includes(item)) {
      return true;
    }
    return false;
  })
 /*  if(config.url.includes('api.forclass.net/notes') 
  || config.url.includes('api/Course') 
  || config.url.includes('api/course')) */
  // end add by daqing
  if(flag){
    if (config.url !== '/login') {   //设置请求头  签名
      var session = ''
      try{
         session = Vue.prototype.loadAccount().session
      }catch(err){
        console.log(err)
        var search = window.location.search;
        if(search.includes('session=')){
          session = search.split('session=')[1]
        }else{
          session = ''
        }
      } 
      config.headers.Author = session
    }    
  }else{
    if (config.url !== '/login') {   //设置请求头  签名
      var a = ''
      try{
         a = Vue.prototype.loadAccount().session
      }catch(err){
        console.log(err)
        var search = window.location.search;
        if(search.includes('session=')){
          a = search.split('session=')[1]
        }
      } 
      var session = btoa(encodeURI(a))
      config.headers.Authorization = `Bearer ${session}`
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// 响应拦截器
request.interceptors.response.use( (response)=> {
  // Vue.prototype.stopLoading()
  // if (response.data.meta.status === 401) {
    //   router.replace('/login')
    // }
    return response
  }, function (error) {
    if(error.toString().includes('401')){
      Vue.prototype.$notify.error({
        title: '警告',
        message: '无权限访问！'
      });
      Vue.prototype.stopLoading()
    }
  return Promise.reject(error)
})



export default request
// export default {}



// WEBPACK FOOTER //
// ./src/axios/request.js